import {useNavigate} from "react-router";
import useRouteMatch from "@Routing/hooks/useRouteMatch";

export default function useGoBack() {
    const navigate = useNavigate()
    const isCheckOrder = useRouteMatch('checkOrder')

    const goBack = () => {
        // If user has landed directly on additional info screen there
        // will not be any history to go back to so navigate to previous route in stack
        // checkOrder uses useResolvePreviousRouteFromCheckOrderData function if there is no history
        // Note: When on check-order page, the back button uses useResolvePreviousRouteFromCheckOrderData
        // which handles the page refresh, so this path is mainly for browser back navigation
        if (history.length > 3 || isCheckOrder) {
            navigate(-1)
        } else {
            navigate("..")
        }
    }

    return {
        goBack,
    }
}